import { Button, DateInput, LabeledDiv, useTranslate } from '@synqo/frontend-component-library';
import { type ComponentProps } from 'react';

interface CompletedAtFieldProps {
    field: Omit<ComponentProps<typeof DateInput>, 'type' | 'label'>;
    hasContainerLines: boolean;
    containersBooked: boolean;
}

/**
 * "Erledigt am": with container lines offered as "schon gefahren?", and removable once set. Fixed once a container
 * is booked.
 */
// @ai-generated 2026-10-28T14:49:12+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5
export function CompletedAtField({ field, hasContainerLines, containersBooked }: CompletedAtFieldProps) {
    const i18n = useTranslate('');
    const label = i18n('Erledigt am');

    if (hasContainerLines && !field.value && !field.locked && !field.readOnly) {
        return (
            <LabeledDiv label={label}>
                <Button
                    appearance="dashed"
                    size="sm"
                    fullWidth
                    onClick={() => void field.onConfirm?.(new Date().toISOString())}
                >
                    {i18n('schon gefahren?')}
                </Button>
            </LabeledDiv>
        );
    }

    return (
        <DateInput
            {...field}
            readOnly={field.readOnly || containersBooked}
            type="datetime"
            label={label}
            maxDate={hasContainerLines ? new Date() : undefined}
            clearable
        />
    );
}
